module.exports = __webpack_public_path__ + "static/4-52c957edce7910307e51d87051ac7017.png";